export default "__VITE_PUBLIC_ASSET__8f1bf890__"